/* global axios */
/* eslint class-methods-use-this: ["error", { "exceptMethods": ["getAccountScopedUrl"] }] */

import ApiClient from './ApiClient';

class KanbanApi extends ApiClient {
  constructor() {
    super('kanban/pipelines', { accountScoped: true });
  }

  getPipelines(params = {}) {
    return axios.get(this.url, { params });
  }

  getPipeline(pipelineId) {
    return axios.get(`${this.url}/${pipelineId}`);
  }

  createPipeline(payload) {
    // Estruturar os dados corretamente para o backend
    const data = {
      pipeline: {
        name: payload.name,
        description: payload.description,
        settings: payload.settings || {}
      },
      columns: payload.columns || []
    };
    
    return axios.post(this.url, data);
  }

  updatePipeline(pipelineId, payload) {
    console.log('API updatePipeline - pipelineId:', pipelineId);
    console.log('API updatePipeline - payload:', payload);
    console.log('API updatePipeline - payload.columns:', payload.columns);
    
    // Estruturar os dados corretamente para o backend
    const data = {
      pipeline: {
        name: payload.name,
        description: payload.description,
        settings: payload.settings || {}
      },
      columns: payload.columns || []
    };
    
    console.log('API updatePipeline - structured data:', data);
    console.log('API updatePipeline - structured data.columns:', data.columns);
    
    return axios.put(`${this.url}/${pipelineId}`, data);
  }

  deletePipeline(pipelineId) {
    return axios.delete(`${this.url}/${pipelineId}`);
  }

  getColumns(pipelineId, params = {}) {
    return axios.get(`${this.url}/${pipelineId}/columns`, { params });
  }

  createColumn(pipelineId, payload) {
    return axios.post(`${this.url}/${pipelineId}/columns`, payload);
  }

  updateColumn(pipelineId, columnId, payload) {
    return axios.put(`${this.url}/${pipelineId}/columns/${columnId}`, payload);
  }

  deleteColumn(pipelineId, columnId) {
    return axios.delete(`${this.url}/${pipelineId}/columns/${columnId}`);
  }

  moveConversation(pipelineId, columnId, payload) {
    return axios.post(
      `${this.url}/${pipelineId}/columns/${columnId}/move_conversation`,
      payload
    );
  }

  removeConversationFromPipeline(pipelineId, columnId, conversationId) {
    return axios.delete(
      `${this.url}/${pipelineId}/columns/${columnId}/remove_conversation`,
      { 
        params: { conversation_id: conversationId }
      }
    );
  }
}

export default new KanbanApi();

